<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <template slot="activator">
        <button v-bind:class="btnClass">{{ btnText }}<span v-html="icon"></span></button>
      </template>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ title }}
          <button type="button" class="close ml-auto" data-dismiss="modal" aria-label="Close" @click="dialog = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </v-card-title>
        <v-card-text>
          <span v-html="content"></span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="primary"
            flat
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import sortBy from 'lodash/sortBy'
  import bowser from 'bowser'
  import _get from 'lodash/get'

  export default {
    props: ['tiers', 'type', 'btnText', 'titleText', 'xstyle', 'cssClass', 'placement'],
    data () {
      return {
        dialog: false,
        extraColorFee: RB.extra_print_color_fee
      }
    },
    computed: {
      trigger () {
        return bowser.mobile ? 'click' : 'hover focus'
      },
      placementPosition () {
        return this.placement ? this.placement : 'top'
      },
      isLargeStyle () {
        return typeof this.xstyle !== 'undefined' && this.xstyle === 'lg'
      },
      btnClass () {
        let cls = 'tiered-pricing-chart btn btn-link btn-sm'
        if (this.isLargeStyle) {
          cls = 'btn-tiered-pricing btn btn-link'
        }

        if (this.cssClass) {
          cls += ' ' + this.cssClass
        }

        return cls
      },
      icon () {
        let icon = ''
        if (this.isLargeStyle) {
          icon += '<i class="fas fa-play"></i>'
        }
        return icon
      },
      title () {
        let mapTitles = {
          'product': this.customband.product.name,
          'custom_art': 'Custom Artwork',
          'phrase': 'Extra Side',
          'color_fill': 'Text Color',
          'barcode': 'Barcode',
          'serial': 'Serial'
        }

        let title = mapTitles[this.type]
        if (typeof this.titleText !== 'undefined') {
          title = this.titleText
        }

        return title
      },
      priceTiers () {
        let priceTiers = this.tiers
        let minQty = this.customband.getMinimumOrderQuantity()

        // Set the correct cost table
        if (typeof priceTiers !== 'undefined') {
          priceTiers = sortBy(priceTiers, 'min')

          // Filter out ranges below the minimum quantity
          priceTiers = priceTiers.filter(tier => tier.min >= minQty)
        }

        // Reformat tiers for color fill
        let maxPrintColors = this.customband.maxPrintColors()
        if (this.type === 'color_fill') {
          let newTiers = []
          if (priceTiers) {
            for (let tier of priceTiers) {
              let oneColorPrice = Number(tier.price)
              let newTier = {
                'min': tier.min,
                'max': tier.max,
                'price': oneColorPrice
              }
              if (maxPrintColors > 1) {
                newTier.additional = this.extraColorFee
              }
              newTiers.push(newTier)
            }
          }
          priceTiers = newTiers
        }

        return priceTiers
      },
      content () {
        let html = ''
        let quantityLabel = 'Quantity'
        let bodyStart = ''
        let cols = []
        let maxPrintColors = this.customband.maxPrintColors()

        let mapCostHeader = {
          'product': 'Price/Band',
          'custom_art': 'Extra Per Band',
          'phrase': 'Extra Per Band',
          'color_fill': 'Extra Per Band',
          'barcode': 'Extra Per Band',
          'serial': 'Extra Per Band'
        }

        if (this.type === 'color_fill') {
          if (maxPrintColors > 1) {
            cols.push('1&nbsp;Color', 'More Colors')
          } else {
            cols.push('1&nbsp;Color')
          }
        } else {
          cols.push(mapCostHeader[this.type])
        }

        html = bodyStart + '<table class="table table-striped table-condensed table-sm"><thead><tr><th>'
        html += quantityLabel + '</th>'
        for (let col of cols) {
          html += '<th>' + col + '</th>'
        }
        html += '</tr></thead><tbody>'

        let discountPercent = _get(this.customband, 'discount.percent', 0)
        let discountMax = _get(this.customband, 'discount.max_quantity')

        let lastDiscountPrice = 0
        let numOfTiers = this.priceTiers.length
        let i = 0
        for (let tier of this.priceTiers) {
          if (i + 1 === numOfTiers) {
            html += '<tr><td>' + tier.min + '+</td>'
          } else {
            html += '<tr><td>' + tier.min + ' - ' + tier.max + '</td>'
          }

          let price = tier.price
          if (this.type === 'product') {
            if (discountPercent > 0) {
              if (discountMax) {
                if (tier.min >= discountMax) {
                  price = lastDiscountPrice
                } else {
                  price -= tier.price * (discountPercent / 100)
                  lastDiscountPrice = price
                }
              } else {
                price -= tier.price * (discountPercent / 100)
                lastDiscountPrice = price
              }
            }
          }

          if (tier.price !== price) {
            html += '<td><s>$' + parseFloat(Math.round(tier.price * 100) / 100).toFixed(2) + '</s> <span class="green">$' + parseFloat(Math.round(price * 100) / 100).toFixed(2) + '</span></td>'
          } else {
            html += '<td>$' + parseFloat(Math.round(tier.price * 100) / 100).toFixed(2) + '</td>'
          }
          if (typeof tier.additional !== 'undefined') {
            html += '<td>$' + parseFloat(Math.round(tier.additional * 100) / 100).toFixed(2) + '</td>'
          }
          html += '</tr>'

          i++
        }
        html += '<tbody></table>'

        return html
      },
      ...mapState([
        // map this.customband to store.state.customband
        'customband'
      ])
    },
    mounted () {
      // console.log('this.tiers', this.tiers)
    }
  }
</script>
